import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { dashboardWorkspaceApi } from '~/utils/api';

export const getOneById = async (workspaceId: string) =>
  dashboardWorkspaceApi.get<RcInstanceDTO.Workspace>(`/workspaces/${workspaceId}`);

export const editOneById = async (workspaceId: string, workspace: RcInstanceDTO.Workspace) =>
  dashboardWorkspaceApi.put<RcInstanceDTO.Workspace>(`/workspaces/${workspaceId}`, {
    ...workspace,
  });

export const deleteOneById = async (workspaceId: string) =>
  dashboardWorkspaceApi.delete<RcInstanceDTO.Workspace>(`/workspaces/${workspaceId}`);

export const deleteWorkspaceData = async (workspaceId: string) =>
  dashboardWorkspaceApi.delete<RcInstanceDTO.Workspace>(`/workspaces/${workspaceId}/data`);

export const inviteUser = async (workspaceId: string, email: string) =>
  dashboardWorkspaceApi.post<RcInstanceDTO.WorkspaceInvitation>(
    `/workspaces/${workspaceId}/invites`,
    {
      email,
    },
  );

export const addUserToWorkspace = async (
  workspaceId: string,
  { email, realmId }: { email: string; realmId?: string },
) =>
  dashboardWorkspaceApi.post<
    RcInstanceDTO.UserWithWorkspaceRole | RcInstanceDTO.WorkspaceInvitation
  >(`/workspaces/${workspaceId}/members`, { email, realmId });

export const getWorkspaceMembers = async (workspaceId: string) =>
  dashboardWorkspaceApi.get<RcInstanceDTO.UserWithWorkspaceRole[]>(
    `/workspaces/${workspaceId}/members`,
  );

export const removeWorkspaceMember = async (workspaceId: string, userId: string) =>
  dashboardWorkspaceApi.delete<RcInstanceDTO.UserWorkspaceRelation>(
    `/workspaces/${workspaceId}/members/${userId}`,
  );

export const getWorkspaceOutgoingInvites = async ({
  workspaceId,
  realmId,
}: {
  workspaceId: string;
  realmId?: string;
}) =>
  dashboardWorkspaceApi.get<RcInstanceDTO.WorkspaceInvitationWithConfirmUrl[]>(
    `/workspaces/${workspaceId}/invites`,
    realmId !== undefined
      ? {
          realmId,
        }
      : undefined,
  );

export const deleteWorkspaceInvite = async (workspaceId: string, inviteId: string) =>
  dashboardWorkspaceApi.delete<number>(`/workspaces/${workspaceId}/invites/${inviteId}`);

export const listWorkspaceRoles = async (workspaceId: string) =>
  dashboardWorkspaceApi.get<RcInstanceDTO.SimplifiedWorkspaceRole[]>(
    `/workspaces/${workspaceId}/roles`,
  );

export const setWorkspaceRole = async (workspaceId: string, userId: string, roleId: string) =>
  dashboardWorkspaceApi.put<RcInstanceDTO.UserWithWorkspaceRole>(
    `/workspaces/${workspaceId}/members/${userId}/role`,
    {
      roleId,
    },
  );
